import { type TFunction } from 'i18next'
import { EmploymentType, PriceIntentNotificationType, type ProductOfferFragment } from '@/services/graphql/generated'

export function isPaymentProtectionProduct(productName: string) {
  return productName === 'SE_PAYMENT_PROTECTION'
}

export function isPaymentProtectionOffer(offer: ProductOfferFragment) {
  return isPaymentProtectionProduct(offer.product.name)
}

export function isUnsupportedEmploymentType(employmentType: EmploymentType) {
  return employmentType === EmploymentType.Unemployed
}

type EmploymentTypeNotification = { type: PriceIntentNotificationType; message: string }

export function getEmploymentTypeNotification(employmentType: EmploymentType, t: TFunction<'purchase-form'>) {
  const notifications: Record<EmploymentType, EmploymentTypeNotification> = {
    [EmploymentType.PermanentEmployedFulltime]: {
      type: PriceIntentNotificationType.Info,
      message: t('EMPLOYMENT_TYPE_PERMANENT_EMPLOYED_FULL_TIME_NOTIFICATION'),
    },
    [EmploymentType.PermanentEmployedParttime]: {
      type: PriceIntentNotificationType.Info,
      message: t('EMPLOYMENT_TYPE_PERMANENT_EMPLOYED_PART_TIME_NOTIFICATION'),
    },
    [EmploymentType.ContractEmployed]: {
      type: PriceIntentNotificationType.Info,
      message: t('EMPLOYMENT_TYPE_CONTRACT_EMPLOYED_NOTIFICATION'),
    },
    [EmploymentType.SelfEmployed]: {
      type: PriceIntentNotificationType.Info,
      message: t('EMPLOYMENT_TYPE_SELF_EMPLOYED_NOTIFICATION'),
    },
    [EmploymentType.Unemployed]: {
      type: PriceIntentNotificationType.Warning,
      message: t('EMPLOYMENT_TYPE_UNEMPLOYED_NOTIFICATION'),
    },
  }

  // employmentType is read from the untyped priceIntentData JSON, so it can hold a value this
  // version of the app doesn't know about.
  return notifications[employmentType] as EmploymentTypeNotification | undefined
}
